module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/cee62341950cabe9e68bb30590b8296b.gif";